export const spanishUi: Record<string, string> = {
  "Search…": "Buscar…", Search: "Buscar", "Choose an option": "Selecciona una opción",
  "No options": "Sin opciones", "No results": "Sin resultados", "No matches": "Sin coincidencias",
  "Nothing matches your search or filters.": "No hay coincidencias con tu búsqueda o filtros.",
  "Clear filters": "Limpiar filtros", Clear: "Limpiar", "Filter by": "Filtrar por",
  "Nothing here yet": "Aún no hay registros", "There is no data to show yet.": "Aún no hay datos para mostrar.",
  "Comfortable view": "Vista amplia", "Compact view": "Vista compacta", "Export CSV": "Exportar CSV",
  "Rows per page": "Filas por página", Pagination: "Paginación", "Previous page": "Página anterior",
  "Next page": "Página siguiente", Page: "Página", of: "de", item: "registro", items: "registros",
  "filtered from": "filtrado de", "More actions": "Más acciones", Close: "Cerrar", Cancel: "Cancelar",
  "(optional)": "(opcional)", "No date": "Sin fecha", calendar: "calendario", Today: "Hoy",
  "Clear date": "Borrar fecha", "Previous month": "Mes anterior", "Next month": "Mes siguiente",
  "Calendar year": "Año del calendario", January: "Enero", February: "Febrero", March: "Marzo",
  April: "Abril", May: "Mayo", June: "Junio", July: "Julio", August: "Agosto",
  September: "Septiembre", October: "Octubre", November: "Noviembre", December: "Diciembre",
  Mon: "Lun", Tue: "Mar", Wed: "Mié", Thu: "Jue", Fri: "Vie", Sat: "Sáb", Sun: "Dom",
  Cut: "Cortar", Copy: "Copiar", Paste: "Pegar", "Select all": "Seleccionar todo", Edit: "Editar",
};
